(function(){
    'use strict'

    angular
    .module('app.eventos')
    .controller('eventos.Edit', Edit);

    Edit.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Edit($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiEventos = 'api/Eventos';

        let vm = this;

        vm.data = {
            estado: 0,
            monedaId: 0,
            fechaInicio: moment().toDate(), 
            fechaFinal: moment().toDate(),
            dias: 0,
            eventoPadreId: 0
        };

        vm.title = 'Eventos';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        vm.estados = [];
        vm.monedas = [];
        vm.eventos = [];

        vm.uiData = {
            fechaInicioOpened: false,
            fechaFinalOpened: false,
            openFechaInicio(){
                this.fechaInicioOpened = !this.fechaInicioOpened;
            },
            openFechaFinal(){
                this.fechaFinalOpened = !this.fechaFinalOpened;
            }
        };

        var promiseEstados = getComboData(vm.estados, 'api/EventoEstados', null, 'Error al cargar los estados');
        var promiseMonedas = getComboData(vm.monedas, 'api/Monedas', null, 'Error al cargar las monedas');
        var promiseEventos = getComboData(vm.eventos, 'api/Eventos/All-Except-Id', [vm.id], 'Error al cargar los eventos');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        get();

        function get(){

            $q.all([promiseEstados, promiseMonedas, promiseEventos])
            .then(function(){

                if(vm.id != 0){
                    ApiBaseService.remoteController = apiEventos;
                    var promise = ApiBaseService.getAll([vm.id]);

                    promise
                    .then(function(data){
                        data.fechaInicio = moment(data.fechaInicio).toDate();
                        data.fechaFinal = moment(data.fechaFinal).toDate();
                        vm.data = data;
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }
            });
        };

        function doFormValidations()
        {
            validateSelectProperty($scope.dataForm, vm.data, 'estado' );
            validateSelectProperty($scope.dataForm, vm.data, 'monedaId' );
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function create() {
            ApiBaseService.remoteController = apiEventos;
            var promise = ApiBaseService.save(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro creado con éxito.');
                clearData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            ApiBaseService.remoteController = apiEventos;
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/eventos');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                estado: 0,
                moendaId: 0,
                fechaInicio: moment().toDate(), 
                fechaFinal: moment().toDate()
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "estado":
                    onEstadoChanged(property);
                    break;
                case "monedaId":
                    onMonedaIdChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onEstadoChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };

        function onMonedaIdChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };

    }
})();